import { useEffect, useRef } from 'react';

import './modal.scss';
import VideoModalWindow from './VideoContent';
import ContactFormModal from './ContactFormModal';
import ExampleOfReport from './ExampleOfReport';

const ModalWindow = ({ isOpen, onClose, modalType }) => {
  const modalContainerRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (modalContainerRef.current && modalContainerRef.current === e.target) {
        isOpen && onClose();
      }
    };

    window.addEventListener('click', onClickOutside);
    return () => {
      window.removeEventListener('click', onClickOutside);
    };
  });

  return (
    <dialog className={`${isOpen ? 'open' : ''}`} ref={modalContainerRef}>
      {isOpen && modalType === 'contactForm' ? (
        <ContactFormModal onClose={onClose} />
      ) : null}
      {isOpen && modalType === 'video' ? (
        <VideoModalWindow onClose={onClose} />
      ) : null}
      {isOpen && modalType === 'report' ? (
        <ExampleOfReport onClose={onClose} />
      ) : null}
    </dialog>
  );
};

export default ModalWindow;
